import { classNamesFunction, FocusZone, mergeStyles, useTheme } from '@fluentui/react';
import React from 'react';
import { tenantGroupStyles } from './TenantGroup.styles';
import { ITenantGroupStyles } from './TenantGroup.styles';

interface ITenantGroupProps {
  readonly name: string;
  children: React.ReactNode;
}

const getClassNames = classNamesFunction<ITenantGroupProps, ITenantGroupStyles>();

export const TenantGroup: React.FC<ITenantGroupProps> = ({ name, children }) => {
  const style = tenantGroupStyles();
  const classNames = getClassNames(style);
  const theme = useTheme();

  return (
    <>
      <h2 className={mergeStyles(style.sectionTitle, { fontSize: theme.fonts.medium.fontSize })}>{name}</h2>
      <FocusZone>
        <ul className={classNames.container}>{children}</ul>
      </FocusZone>
    </>
  );
};
